// GENERATED — intrinsic pixel dimensions of the landing product screenshots,
// keyed by basename. Used to reserve the hero/feature image box up-front (the
// browser computes the aspect-ratio from width/height) so the initial page load
// has NO layout shift. Regenerate with `deno task promote` (lona-screenshot)
// whenever the webp are re-captured.
export const LANDING_ASSET_DIMENSIONS: Record<
  string,
  { width: number; height: number }
> = {
  "feature-ai-chat.webp": { width: 3024, height: 2268 },
  "feature-calendar.webp": { width: 2400, height: 1600 },
  "feature-finance.webp": { width: 3000, height: 1344 },
  "feature-home-cards.webp": { width: 2880, height: 1600 },
  "feature-home-list.webp": { width: 2880, height: 1600 },
  "feature-journal.webp": { width: 2560, height: 1824 },
  "feature-scheduling.webp": { width: 2160, height: 1400 },
  "feature-sidebar-home.webp": { width: 2880, height: 1520 },
  "feature-sidebar-sheets.webp": { width: 2880, height: 1520 },
  "feature-sidebar-stickers.webp": { width: 2880, height: 1520 },
  "feature-sidebar-tasks.webp": { width: 2880, height: 1520 },
};
